module.exports = __webpack_public_path__ + "media/images/backgrounds/how_to-1a8c8c3caeba2d5439ee8d9b83261c72.svg";